<template>
  <section class="stats-section py-8">
    <v-container>
      <div class="stats-card-wrapper">
        <v-row no-gutters>
          <v-col
            v-for="(stat, index) in stats"
            :key="index"
            cols="6"
            md="3"
            class="stat-item pa-4 pa-md-6"
            :class="{ 'border-right': index !== stats.length - 1 }"
          >
            <div class="d-flex flex-column align-center text-center">
              <div class="stat-icon-wrapper mb-2">
                <v-icon color="primary" size="28">{{ stat.icon }}</v-icon>
              </div>
              <div class="text-h4 text-md-h3 font-weight-black text-primary mb-1">
                {{ stat.value }}
              </div>
              <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-1">
                {{ stat.title }}
              </div>
              <div class="text-caption text-grey-darken-1">
                {{ stat.subtitle }}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'StatsBar',
  data() {
    return {
      stats: [
        {
          icon: 'mdi-calendar-check',
          value: '17+ Años',
          title: 'De Trayectoria',
          subtitle: 'Experiencia inmobiliaria desde 2009',
        },
        {
          icon: 'mdi-map-marker-radius-outline',
          value: '7 Municipios',
          title: 'Norte de Cundinamarca',
          subtitle: 'Sopó, Zipaquirá, Tocancipá y más',
        },
        {
          icon: 'mdi-shield-check-outline',
          value: '100% Seguridad',
          title: 'Estudio de Títulos',
          subtitle: 'Respaldamos jurídicamente cada predio',
        },
        {
          icon: 'mdi-home-city-outline',
          value: '+50',
          title: 'Inmuebles Gestionados',
          subtitle: 'Operaciones de venta y arriendo con éxito',
        },
      ],
    };
  },
};
</script>

<style scoped>
.stats-section {
  position: relative;
  z-index: 10;
  margin-top: -40px;
}

.stats-card-wrapper {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(169, 7, 7, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.stats-card-wrapper:hover {
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.12);
}

.stat-item {
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.stat-item:hover {
  background-color: rgba(169, 7, 7, 0.02);
  transform: translateY(-2px);
}

.stat-icon-wrapper {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(169, 7, 7, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-right {
  border-right: 1px solid #f0f0f0;
}

@media (max-width: 960px) {
  .stats-section {
    margin-top: -20px;
  }
  .border-right {
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
  }
}
</style>
